import { useEffect, useState } from 'react';
import './Homepage1.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import 'animate.css/animate.min.css';
import wh1 from '../assets/wh1.jpg';
import wh2 from '../assets/wh2.avif';
import wh3 from '../assets/wh3.png';
import wh4 from '../assets/wh4.webp';
import logo from '../assets/logowbg.png';
import stalin from '../assets/stalin.jpg';
import tnwclogo from '../assets/tnwclogo.avif';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const NAV_TABS = ['Home', 'About', 'Statistics', 'Services', 'Tenders', 'Documents', 'RTI', 'Gallery', 'Other Links', 'Contact Us', 'Login'];

function Navbar() {
  return (
    <>
      {/* Top Navbar: Images */}
      <nav className="navbar navbar-expand-lg bg-light shadow-sm py-2">
        <div className="container d-flex justify-content-between align-items-center">
          <span className="navbar-brand d-flex align-items-center">
            <img
              src={tnwclogo}
              alt="Tamil Nadu Warehousing Logo"
              style={{ height: '90px', width: 'auto' }}
            />

            <div className="brand-text">
              <div style={{ fontWeight: '700', fontSize: '0.8rem', color: '#1c1464', lineHeight: 1.1 }}>
                தமிழ்நாடு சேமிப்புக் கிடங்கு நிறுவனம்
              </div>
              <div style={{ fontWeight: '400', fontSize: '0.5rem', color: '#bf4040', marginBottom: '0.25rem' }}>
                (தமிழ் அரசு சார்பு நிறுவனம்)
              </div>
              <div style={{ fontWeight: '700', fontSize: '0.8rem', color: '#1c1464', lineHeight: 1.1 }}>
                TAMIL NADU WAREHOUSING CORPORATION
              </div>
              <div style={{ fontWeight: '400', fontSize: '0.5rem', color: '#bf4040' }}>
                (A Government of Tamil Nadu Sponsored Undertaking)
              </div>
            </div>
          </span>

          <span className="navbar-brand d-flex align-items-center gap-2">
            <img
              src={logo}
              alt="Tamil Nadu Warehousing Logo"
              style={{ height: '90px', width: 'auto' }}
            />
            <div className="brand-labels d-flex align-items-end flex-column justify-content-end" >
              <h6 className="mb-1 fw-bold text-primary">MK STALIN</h6>
              <p className="mb-0 text-muted small fst-italic" style={{ whiteSpace: 'nowrap', fontSize: '.8rem' }}>
                Hon’ble Chief Minister Govt. of Tamil Nadu
              </p>
            </div>

            <span className="navbar-brand fw-bold text-primary">
              <img
                src={stalin}
                alt="MK Stalin"
                className="rounded-circle"
                style={{ height: '90px', width: '90px', objectFit: 'cover', border: '3px solid #0d6efd' }}
              />

            </span>
          </span>
        </div>
      </nav>

      {/* Bottom Navbar: Navigation Links */}
      <nav
        className="navbar navbar-expand-lg shadow-sm text-light"
        style={{ backgroundColor: 'rgba(2, 30, 73, 1).47)' }}
      >
        <div className="container">
          <ul className="navbar-nav mx-auto">
            {NAV_TABS.map(tab => (
              <li className="nav-item mx-3" key={tab}>
                <span className="nav-link fw-semibold text-light"
                  style={{ fontWeight: '700', fontSize: '0.9rem' }}
                >{tab}</span>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
}

function Hero() {
  const images = [wh2, wh3, wh1];

  useEffect(() => {
    const carouselEl = document.getElementById('heroCarousel');
    const carousel = new bootstrap.Carousel(carouselEl, {
      interval: 5000, 
      ride: 'carousel', 
      pause: 'hover',  
      wrap: true 
    });
    return () => carousel.dispose();
  }, []);

  return (
    <section style={{ height: '100vh', position: 'relative' }}>
      {/* Carousel */}
      <div
        id="heroCarousel"
        className="carousel slide carousel-fade"
        style={{ height: '100vh' }}
      >
        <div className="carousel-inner">
          {images.map((img, idx) => (
            <div
              key={idx}
              className={`carousel-item ${idx === 0 ? 'active' : ''}`}
            >
              <img
                src={img}
                className="d-block w-100"
                alt={`Slide ${idx + 1}`}
                style={{ height: '100vh', objectFit: 'cover' }}
              />
            </div>
          ))}
        </div>

        {/* Prev / Next Buttons */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" />
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#heroCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" />
        </button>

        {/* Indicators */}
        <div className="carousel-indicators">
          {images.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide-to={idx}
              className={idx === 0 ? 'active' : ''}
              aria-current={idx === 0}
            />
          ))}
        </div>
      </div>

      {/* Overlay Content */}
      <div
        className="d-flex align-items-center justify-content-center text-center animate__animated animate__fadeIn"
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.3)',
          color: 'white',
          zIndex: 2,
          pointerEvents: 'none', // allows clicking buttons underneath
        }}
      >
        <div className="container" style={{ pointerEvents: 'auto' }}>
          <p className="lead mb-4 fw-semibold">
            Efficient Storage Solutions for Tamil Nadu's Growth
          </p>
          <h1 className="display-2 fw-bold mb-4">
            Tamil Nadu Warehousing
          </h1>
          <p className="mb-4">
            Supporting agriculture, industries, and logistics with cutting-edge storage facilities.
          </p>
          <button className="btn btn-success btn-lg animate__animated animate__pulse animate__infinite">
            Explore Now
          </button>
        </div>
      </div>
    </section>
  );
}

// function ImageSlider() {
//   const images = [
//     { src: { wh1 }, alt: 'Tamil Nadu Warehouse 1' },
//     { src: { wh1 }, alt: 'Tamil Nadu Warehouse 2' },
//     { src: { wh1 }, alt: 'Tamil Nadu Warehouse 3' },
//   ];

//   return (
//     <div id="warehouseSlider" className="carousel slide" data-bs-ride="carousel" style={{ marginTop: '70px' }}>
//       {/* Indicators */}
//       <div className="carousel-indicators">
//         {images.map((_, idx) => (
//           <button
//             key={idx}
//             type="button"
//             data-bs-target="#warehouseSlider"
//             data-bs-slide-to={idx}
//             className={idx === 0 ? 'active' : ''}
//             aria-current={idx === 0 ? 'true' : ''}
//             aria-label={`Slide ${idx + 1}`}
//           ></button>
//         ))}
//       </div>

//       {/* Carousel Images */}
//       <div className="carousel-inner">
//         {images.map((image, idx) => (
//           <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
//             <img
//               src={image.src}
//               className="d-block w-100"
//               alt={image.alt}
//               style={{ height: '100vh', objectFit: 'cover' }}
//             />
//           </div>
//         ))}
//       </div>

//       {/* Navigation Arrows */}
//       <button
//         className="carousel-control-prev"
//         type="button"
//         data-bs-target="#warehouseSlider"
//         data-bs-slide="prev"
//       >
//         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Previous</span>
//       </button>
//       <button
//         className="carousel-control-next"
//         type="button"
//         data-bs-target="#warehouseSlider"
//         data-bs-slide="next"
//       >
//         <span className="carousel-control-next-icon" aria-hidden="true"></span>
//         <span className="visually-hidden">Next</span>
//       </button>
//     </div>
//   );
// }

function About() {
  return (
    <section className="about-section py-5" >
      <div className="container" >
        {/* Title */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">About Tamil Nadu Warehousing</h2>
          <p className="text-muted mt-2">
            Strengthening storage, supply chains, and economic growth
          </p>
        </div>

        <div className="row align-items-center g-5">
          {/* LEFT CONTENT */}
          <div className="col-md-6" data-aos="fade-right">
            <h4 className="fw-semibold mb-3">
              Reliable & Strategic Warehousing Solutions
            </h4>
            <p className="text-muted">
              Tamil Nadu Warehousing Corporation (TNWC) plays a vital role in
              strengthening the agricultural and industrial backbone of the
              state. With a widespread network of strategically located
              warehouses, we ensure safe, secure, and efficient storage of
              commodities.
            </p>
            <p className="text-muted">
              Our warehouses are equipped with modern infrastructure, advanced
              inventory management systems, and quality control measures to
              reduce post-harvest losses and improve supply chain efficiency.
            </p>

            {/* FEATURES */}
            <div className="row mt-4" data-aos="zoom-in" data-aos-delay="90000" >
              {[
                'Modern Storage Infrastructure',
                'Cold & Dry Storage Facilities',
                'Strategic Locations Across Tamil Nadu',
                'Secure & Insured Warehouses',
              ].map((item, idx) => (
                <div key={idx} className="col-6 mb-3">
                  <div className="about-feature">
                    <span>✔</span> {item}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT CARDS */}
          <div className="col-md-6" data-aos="fade-left" data-aos-delay="200">
            <div className="row g-4">
              <div className="col-6">
                <div className="about-card shadow-sm">
                  <h3>50+</h3>
                  <p>Warehouses</p>
                </div>
              </div>
              <div className="col-6">
                <div className="about-card shadow-sm">
                  <h3>10L+</h3>
                  <p>MT Storage Capacity</p>
                </div>
              </div>
              <div className="col-6">
                <div className="about-card shadow-sm">
                  <h3>24/7</h3>
                  <p>Security & Monitoring</p>
                </div>
              </div>
              <div className="col-6">
                <div className="about-card shadow-sm">
                  <h3>100%</h3>
                  <p>Quality Assurance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Services() {
  const services = [
    {
      icon: 'bi-snow',
      title: 'Cold Storage',
      desc: 'Temperature-controlled storage solutions to preserve agricultural produce and perishable goods.',
      points: [
        'Multi-temperature zones',
        'Reduced post-harvest losses',
        '24/7 monitoring',
        'Quality preservation',
      ],
    },
    {
      icon: 'bi-truck',
      title: 'Logistics Support',
      desc: 'Integrated logistics and transportation services ensuring smooth movement of goods.',
      points: [
        'End-to-end supply chain support',
        'Real-time tracking',
        'Fast distribution network',
        'Trusted logistics partners',
      ],
    },
    {
      icon: 'bi-building',
      title: 'Custom Warehousing',
      desc: 'Flexible and scalable warehousing solutions tailored to business requirements.',
      points: [
        'Custom storage layouts',
        'Bulk & pallet storage',
        'Industry-specific facilities',
        'Cost-effective solutions',
      ],
    },
  ];

  return (
    <section className="services-section py-5">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5 animate__animated animate__fadeInUp">
          <h2 className="fw-bold">Our Services</h2>
          <p className="text-muted">
            Comprehensive warehousing and logistics solutions across Tamil Nadu
          </p>
        </div>

        <div className="row g-4">
          {services.map((service, idx) => (
            <div key={idx} className="col-md-4">
              <div
                className="service-card h-100"
                data-aos="zoom-in"
                data-aos-delay={idx === 1 ? 300 : idx === 2 ? 600 : 0}
              >

                <div className="service-icon">
                  <i className={`bi ${service.icon}`}></i>
                </div>

                <h5 className="fw-semibold mt-3">{service.title}</h5>
                <p className="text-muted">{service.desc}</p>

                <ul className="service-list">
                  {service.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <button className="btn btn-outline-primary btn-sm mt-3">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Portfolio() {
  const locations = [
    {
      wh: wh1,
      city: "Chennai",
      area: "50,000 Sq.ft",
      connectivity: "Port & NH Access"
    },
    {
      wh: wh4,
      city: "Coimbatore",
      area: "35,000 Sq.ft",
      connectivity: "Industrial Hub"
    },
    {
      wh: wh3,
      city: "Madurai",
      area: "25,000 Sq.ft",
      connectivity: "Southern TN"
    }
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Heading */}
        <div
          className="text-center mb-5"
          data-aos="fade-up"
        >
          <h2 className="fw-bold">Our Warehousing Locations</h2>
          <p className="text-muted">
            Strategically located warehouses across Tamil Nadu
          </p>
        </div>

        <div className="row g-4">
          {locations.map((loc, idx) => (
            <div
              className="col-md-4"
              key={idx}
              data-aos="flip-up"
              data-aos-delay={idx * 300}
            >
              <div className="warehouse-card">
                <div
                  className="warehouse-image"
                  style={{ backgroundImage: `url(${loc.wh})` }}
                >
                  <div className="warehouse-overlay">
                    <h5>{loc.city} Warehouse</h5>
                    <p>Area: {loc.area}</p>
                    <p>{loc.connectivity}</p>

                    <button className="btn btn-outline-light btn-sm mt-2">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Contact() {
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    msg: ""
  })

  const handleContact = (e) => {
    e.preventDefault();
    if (contactForm?.name && contactForm?.email && contactForm?.msg) {
      alert("Thank you for contacting us. We will get back to you shortly.");
      setContactForm({
        name: "",
        email: "",
        msg: ""
      })
    } else {
      alert("All Fields are Mandatory");
    }
  }

  return (
    <section className="contact-section py-5">
      <div className="container">

        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-9">

            {/* Heading */}
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="fw-bold">Contact Us</h2>
              <p className="text-muted">
                Get in touch with us for reliable warehousing & logistics solutions
              </p>
            </div>

            <div className="row align-items-stretch">
              {/* Contact Info */}
              <div
                className="col-md-5 mb-4 mb-md-0"
                data-aos="fade-right"
              >
                <div className="contact-info h-100">
                  <h4 className="mb-4">Reach Us</h4>

                  <div className="info-item">
                    <FaMapMarkerAlt />
                    <p>
                      Chennai, Coimbatore & Madurai<br />
                      Tamil Nadu, India
                    </p>
                  </div>

                  <div className="info-item">
                    <FaPhoneAlt />
                    <p>+91 95**470870</p>
                  </div>

                  <div className="info-item">
                    <FaEnvelope />
                    <p>info@tnwc.com</p>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div
                className="col-md-7"
                data-aos="fade-left"
              >
                <div className="contact-form">
                  <form onSubmit={handleContact}>
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Name"
                        value={contactForm?.name}
                        onChange={(e) => setContactForm((pv) => ({ ...pv, name: e.target.value }))}
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>

                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Your Email"
                        value={contactForm?.email}
                        onChange={(e) => setContactForm((pv) => ({ ...pv, email: e.target.value }))}
                      />
                      <label htmlFor="email">Your Email</label>
                    </div>

                    <div className="form-floating mb-3">
                      <textarea
                        className="form-control"
                        placeholder="Your Message"
                        style={{ height: "130px" }}
                        value={contactForm?.msg}
                        onChange={(e) => setContactForm((pv) => ({ ...pv, msg: e.target.value }))}
                      ></textarea>
                      <label htmlFor="message">Your Message</label>
                    </div>

                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn btn-primary contact-btn"
                        data-aos="zoom-in"
                        data-aos-delay="200"
                      >
                        Send Message
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section >
  );
}

function Footer() {
  return (
    <footer className="footer-section bg-primary bg-opacity-10">
      <div className="container py-5">
        <div className="row text-start">

          {/* Company Info */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-3">TNWC</h5>
            <p className="small">
              TNWC provides reliable and secure warehousing and logistics
              solutions across Tamil Nadu, ensuring safe storage and timely
              distribution.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-2 mb-4">
            <h6 className="fw-semibold mb-3">Quick Links</h6>
            <ul className="list-unstyled footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/">Services</a></li>
              <li><a href="/">Locations</a></li>
              <li><a href="/">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-semibold mb-3">Our Services</h6>
            <ul className="list-unstyled footer-links">
              <li>Warehousing</li>
              <li>Cold Storage</li>
              <li>Inventory Management</li>
              <li>Transportation</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 mb-4">
            <h6 className="fw-semibold mb-3">Contact</h6>
            <p className="small mb-1">
              <FaMapMarkerAlt /> Tamil Nadu, India
            </p>
            <p className="small mb-1">
              <FaPhoneAlt /> +91 95**470870
            </p>
            <p className="small">
              <FaEnvelope /> info@tnwc.com
            </p>

            {/* Social Icons */}
            <div className="footer-social d-flex justify-content-start gap-3 mt-3">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedinIn /></a>
            </div>

          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom text-center py-3">
        © 2025 TNWC. All rights reserved.
      </div>
    </footer>
  );
}


export default function Homepage1() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <div style={{ paddingTop: '70px' }}>
        <About />
        <Services />
        <Portfolio />
        <Contact />
      </div>
      <Footer />
    </>
  );
}